module.exports = __webpack_public_path__ + "ci_jira.dc642.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_jira.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_jira.svg
// module chunks = main